module.exports = "<div id=\"map\">\n</div>\n"